import { Container } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';
import { tweenPower2In } from '../../lib/util/tweens';

export class BubbleAnimation extends Container implements IAnimation {
  private smoke: ParticleEmitter;

  constructor() {
    super();
    this.smoke = this.createEmitter();
    this.addChild(this.smoke.view);
  }

  public static assets(): string[] {
    return ['fx.basic/fx.bubble.png'];
  }

  public async start(): Promise<void> {
    return this.smoke.start();
  }

  public stop() {
    this.smoke.stop();
  }

  private createEmitter(): ParticleEmitter {
    return app.particles.create(
      {
        textures: [getMatch2AssetPath('fx.basic/fx.bubble.png')],
        rate: 0.15,
        limit: 64,
        duration: 1,
        velocity: [
          { x: 0, y: -50 },
          { x: 0, y: -25 },
        ],
        scale: [
          { x: 0.5, y: 0.5 },
          { x: 1, y: 1 },
        ],
        behaviors: [
          { type: 'explode', magnitude: [20, 14] },
          { type: 'kinematic' },
          { type: 'fade', to: 0, tween: tweenPower2In },
        ],
      },
      true,
    );
  }
}
